import StarIcon from '../Icons/StarIcon';
import StarIconOutline from '../Icons/StarIconOutline';
import './index.less';

interface IRating {
  rate: number;
  label?: string;
  onLabelClick?: () => void;
  clickableLabel?: string;
}

const Rating = (props: IRating) => {
  const { label, rate, onLabelClick, clickableLabel } = props;

  return (
    <div className="rating">
      {Array.from({ length: 5 }).map((_, index) =>
        Math.floor(rate) > index ? <StarIcon key={'rating' + index} /> : <StarIconOutline key={'rating' + index} />,
      )}
      <div className="label">
        {label}
        {clickableLabel && (
          <span className="clickable" onClick={onLabelClick}>
            {clickableLabel}
          </span>
        )}
      </div>
    </div>
  );
};

export default Rating;
